import { render, staticRenderFns } from "./Colaboracoes.vue?vue&type=template&id=2b67790c&scoped=true"
import script from "./Colaboracoes.vue?vue&type=script&lang=js"
export * from "./Colaboracoes.vue?vue&type=script&lang=js"
import style0 from "./Colaboracoes.vue?vue&type=style&index=0&id=2b67790c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b67790c",
  null
  
)

export default component.exports